<template>
  <!-- Cover art: the picture when there is one, else the two-glow tile. -->
  <div
    class="art-tile"
    :style="{
      width: size + 'px',
      height: size + 'px',
      borderRadius: (radius ?? radiusFor(size)) + 'px',
      background: picture && !failed ? 'var(--cl-raised)' : background,
    }"
  >
    <img
      v-if="picture && !failed"
      :src="picture"
      alt=""
      class="art-img"
      @error="failed = true"
    />
  </div>
</template>

<script>
import { artBackground, radiusFor, seededColors, pooledColors } from "@/kit/art.js";

export default {
  name: "ArtTile",
  props: {
    seed: { type: String, default: "" },
    owner: { type: String, default: null }, // a person colour
    pooled: { type: Boolean, default: false }, // sound and pack art
    picture: { type: String, default: null },
    size: { type: Number, default: 44 },
    radius: { type: Number, default: null },
  },
  data: () => ({ failed: false }),
  computed: {
    background() {
      const colors =
        this.pooled && this.owner
          ? pooledColors(this.seed, this.owner)
          : seededColors(this.seed, this.owner);
      return artBackground(colors);
    },
  },
  watch: {
    picture() {
      this.failed = false;
    },
  },
  methods: { radiusFor },
};
</script>

<style scoped>
.art-tile {
  position: relative;
  flex-shrink: 0;
  overflow: hidden;
}
.art-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
